import { setSpecificMessage, mimeType } from "valibot";
setSpecificMessage(
  mimeType,
  (issue) => `Type MIME invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);